// src/shared/lib/reserveSlug.js
import { doc, runTransaction } from "firebase/firestore";

// ถ้าคุณมี slugify อยู่ที่อื่น ให้ import มาแทนได้เลย
function slugify(str = "") {
  return str
    .toLowerCase()
    .normalize("NFD").replace(/\p{Diacritic}/gu, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}

/**
 * จอง slug แบบไม่ซ้ำ โดยใช้คอลเลกชันดัชนี /slugIndex/{slug}
 * - ถ้าว่าง: สร้างเอกสาร { articleId, createdAt } แล้วคืน slug นั้น
 * - ถ้ามีอยู่แต่เป็นของบทความเดิม: คืน slug นั้น (ถือว่าเป็นของเดิม)
 * - ถ้ามีคนใช้แล้ว: เติม -2, -3, ... จนกว่าจะว่าง
 */
export async function reserveUniqueSlug(db, articleId, desiredSlug) {
  const base = slugify(desiredSlug) || "post";

  return await runTransaction(db, async (tx) => {
    let candidate = base;
    let i = 1;

    while (true) {
      const idxRef = doc(db, "slugIndex", candidate);
      const snap = await tx.get(idxRef);

      if (!snap.exists()) {
        tx.set(idxRef, { articleId, createdAt: Date.now() });
        return candidate;
      }

      // ถ้า slug นี้ผูกกับบทความเดิมอยู่แล้ว ให้ใช้ต่อได้
      if (snap.data()?.articleId === articleId) return candidate;

      i += 1;
      candidate = `${base}-${i}`;
    }
  });
}